/* eslint-disable no-undef */
export const formatDate = (dateString) => {
  const date = new Date(dateString)

  if (isNaN(date)) {
    throw new Error('Invalid time value')
  }

  // Format: Nov 28, 2025, 12:05 PM (EST)
  // JavaScript Date automatically converts UTC to user's local timezone when formatted
  
  // Format date and time
  const formattedDateTime = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }).format(date)

  // Get timezone abbreviation
  const timeZoneAbbr = new Intl.DateTimeFormat('en-US', {
    timeZoneName: 'short'
  }).formatToParts(date).find(part => part.type === 'timeZoneName')?.value || ''

  // Combine: "Nov 28, 2025, 12:05 PM (EST)"
  return `${formattedDateTime} (${timeZoneAbbr})`
}